module.exports = __webpack_public_path__ + "img/slide_4.288a9ace.jpg";